module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1024-fd71f5f045f5ee8e2306cb43f120575b.png";